import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './components/layout/AppShell';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { ModelsPage } from './pages/Models';
import { ModelNewPage } from './pages/ModelNew';
import { ModelDetailPage } from './pages/ModelDetail';
import { ModelEditPage } from './pages/ModelEdit';
import { KeysPage } from './pages/Keys';
import { KeyNewPage } from './pages/KeyNew';
import { KeyDetailPage } from './pages/KeyDetail';
import { KeyEditPage } from './pages/KeyEdit';
import { TeamsPage } from './pages/Teams';
import { UsersPage } from './pages/Users';
import { UserNewPage } from './pages/UserNew';
import { UserDetailPage } from './pages/UserDetail';
import { UserEditPage } from './pages/UserEdit';
import { LogsPage } from './pages/Logs';
import { LogDetailPage } from './pages/LogDetail';
import { PlaygroundPage } from './pages/Playground';
import { SettingsPage } from './pages/Settings';
import { RequireAuth } from './components/auth/RequireAuth';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'models', element: <ModelsPage /> },
      { path: 'models/new', element: <ModelNewPage /> },
      { path: 'models/:id', element: <ModelDetailPage /> },
      { path: 'models/:id/edit', element: <ModelEditPage /> },
      { path: 'keys', element: <KeysPage /> },
      { path: 'keys/new', element: <KeyNewPage /> },
      { path: 'keys/:key', element: <KeyDetailPage /> },
      { path: 'keys/:key/edit', element: <KeyEditPage /> },
      { path: 'teams', element: <TeamsPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'users/new', element: <UserNewPage /> },
      { path: 'users/:id', element: <UserDetailPage /> },
      { path: 'users/:id/edit', element: <UserEditPage /> },
      { path: 'logs', element: <LogsPage /> },
      { path: 'logs/:request_id', element: <LogDetailPage /> },
      { path: 'playground', element: <PlaygroundPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);